"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INITIALRENDITION = void 0;
exports.initialRenditionForCurrentQuality = initialRenditionForCurrentQuality;
exports.normaliseQualities = normaliseQualities;
exports.normaliseQuality = normaliseQuality;
var _QualityUtils = require("../utils/QualityUtils");
var _CodecUtils = require("../utils/CodecUtils");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var INITIALRENDITION = exports.INITIALRENDITION = {
  DEFAULT: 'default',
  FIRST: 'first',
  LOW: 'low',
  HIGH: 'high'
};
function normaliseQuality(src, quality, idx) {
  var width = quality && quality.width;
  var height = quality && quality.height;
  var bandwidth = quality && quality.bandwidth;
  var id = quality && quality.id;
  var key = (0, _QualityUtils.generateQualityKey)(src, height || _QualityUtils.AUTO_LABEL);
  return {
    index: idx,
    key: key,
    id: id,
    width: width || 0,
    height: height || 0,
    bitrate: bandwidth || 0,
    label: (0, _QualityUtils.heightToLabel)(height)
  };
}
function normaliseQualities(src, nativeQualities) {
  var qualities = (0, _QualityUtils.qualitiesRecord)();

  // Only normalise if HLS is available
  if ((0, _QualityUtils.isHLS)(src) && nativeQualities.length >= 1) {
    // Group qualites by resolution
    var heightGroupings = nativeQualities.reduce(function (group, quality) {
      if ((0, _CodecUtils.checkCodecCompatibility)(quality.codecs)) {
        var _group$quality$height;
        group[quality.height] = (_group$quality$height = group[quality.height]) !== null && _group$quality$height !== void 0 ? _group$quality$height : [];
        group[quality.height].push(quality);
      }
      return group;
    }, {});

    // Add Auto rendition option as THEO does not provide one
    var auto = normaliseQuality(src, {}, -1);
    qualities["native"][auto.key] = null;
    qualities.normalised.push(auto);

    // Normalise other renditions
    Object.entries(heightGroupings).forEach(function (_ref, index) {
      var _ref2 = _slicedToArray(_ref, 1),
        key = _ref2[0];
      // Should be updated to use quality score instead of codec name once avalible
      heightGroupings[key] = (0, _QualityUtils.sortQualitiesByCodec)(heightGroupings[key]);

      // Only display quality from best codec per resolution
      var nativeQuality = heightGroupings[key][0];
      var normalised = normaliseQuality(src, nativeQuality, index);
      qualities["native"][normalised.key] = nativeQuality;
      qualities.normalised.push(normalised);
    });
    qualities.normalised = (0, _QualityUtils.sortQualities)(qualities.normalised);
  }
  return qualities;
}
function initialRenditionForCurrentQuality(player, renditions, quality) {
  if (!renditions || !renditions.length || !quality || !player || player.paused || player.ended || player.seeking || !player.videoHeight) {
    return null;
  }
  var allRenditions = (0, _QualityUtils.sortQualities)(renditions);
  if (quality.height === allRenditions[0].height) {
    return INITIALRENDITION.HIGH;
  }
  return INITIALRENDITION.LOW;
}